import { render, staticRenderFns } from "./SafeImage.vue?vue&type=template&id=a365c9c4"
import script from "./SafeImage.vue?vue&type=script&lang=js"
export * from "./SafeImage.vue?vue&type=script&lang=js"
import style0 from "./SafeImage.vue?vue&type=style&index=0&id=a365c9c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports